export default __webpack_public_path__ + "static/lutein-howto-header-bbb398e80e2b33f03df0fb29693173ed.jpg";